/**
 * Review Carousel - Swiper Implementation
 */

class ReviewCarousel {
  constructor(section) {
    this.section = section;
    this.sectionId = section.dataset.sectionId;
    this.desktopCols = parseInt(section.dataset.desktopCols) || 3;
    this.mobileCols = parseInt(section.dataset.mobileCols) || 1;
    this.showArrows = section.dataset.showArrows === 'true';
    
    this.swiperContainer = section.querySelector(`.review-swiper-${this.sectionId}`);
    
    if (this.swiperContainer && typeof Swiper !== 'undefined') {
      this.init();
    }
  }

  init() {
    // Calculate responsive breakpoints
    const breakpoints = {
      // Mobile (< 640px)
      320: {
        slidesPerView: this.mobileCols,
        spaceBetween: 16,
      },
      // Mobile landscape (>= 640px)
      640: {
        slidesPerView: this.mobileCols,
        spaceBetween: 20,
      },
      // Tablet (>= 768px)
      768: {
        slidesPerView: Math.min(this.desktopCols, 2),
        spaceBetween: 24,
      },
      // Desktop (>= 1024px)
      1024: {
        slidesPerView: this.desktopCols,
        spaceBetween: 30,
      },
    };

    const navigationConfig = this.showArrows ? {
      nextEl: `.review-swiper-button-next-${this.sectionId}`,
      prevEl: `.review-swiper-button-prev-${this.sectionId}`,
    } : false;

    this.swiper = new Swiper(`.review-swiper-${this.sectionId}`, {
      slidesPerView: this.mobileCols,
      spaceBetween: 16,
      loop: false,
      grabCursor: true,
      watchOverflow: true,
      
      // Navigation arrows
      navigation: navigationConfig,
      
      // Responsive breakpoints
      breakpoints: breakpoints,

      // Accessibility
      a11y: {
        prevSlideMessage: 'Previous review',
        nextSlideMessage: 'Next review',
      },
    });
  }

  destroy() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
    }
  }
}

// Initialize all review carousels on the page
function initReviewCarousels() {
  const sections = document.querySelectorAll('.review-carousel-section');
  
  sections.forEach(section => {
    // Store the instance on the section element
    if (!section.reviewCarousel) {
      section.reviewCarousel = new ReviewCarousel(section);
    }
  });
}

// Initialize on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initReviewCarousels);
} else {
  initReviewCarousels();
}

// Reinitialize on Shopify theme editor section load
if (window.Shopify && window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', function(event) {
    const section = event.target.querySelector('.review-carousel-section');
    if (section) {
      // Destroy old instance if exists
      if (section.reviewCarousel) {
        section.reviewCarousel.destroy();
      }
      // Create new instance
      setTimeout(() => {
        section.reviewCarousel = new ReviewCarousel(section);
      }, 100);
    }
  });

  document.addEventListener('shopify:section:unload', function(event) {
    const section = event.target.querySelector('.review-carousel-section');
    if (section && section.reviewCarousel) {
      section.reviewCarousel.destroy();
    }
  });
}

